<template>
  <v-row>
    <v-col cols="12">
      <div class="text-body-1 px-5 py-2" v-for="info in infos" :key="info.name">
        <b>{{info.name}}</b><br/>
        <a :href=info.link target="_blank">{{info.link}}</a>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SiteInfo',
  props: {
    infos: Array
  },
}
</script>

<style>
</style>